import { Dashboard, Payment } from '@/components';

export const PaymentPage = () => (
  <Dashboard openLogIn>
    <Payment />
  </Dashboard>
);
